import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from '../Navbar/Navbar';
import StockSidebar from '../../screens/StockManager/StockSidebar';
const ProductionManagerLayout = () => {

  return (
    <div>
    <header>
      <AdminNavbar />
    </header>
    <main>
      <StockSidebar />
      <Outlet mi />
    </main>
    <footer>
      {/* Add your admin footer here */}
    </footer>
  </div>
  );
};
 
export default ProductionManagerLayout;
